export function assert(expressionResult: boolean, ...msgArgs: string[]) {
  if (!expressionResult) {
    throw new Error((msgArgs || []).join(' '));
  }
}
